import { portalAPI } from './portalAPI';

const APIWintimeSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['Wintime'] }).injectEndpoints({
    endpoints: (builder) => ({
        isWintimeIntegrationEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/wintime/enabled',
            keepUnusedDataFor: 10 * 60,
        }),
    }),
    overrideExisting: false,
});

export const { useIsWintimeIntegrationEnabledQuery } = APIWintimeSlice;
